@use "sass:math";
@use "~theme/typography";
@use "~theme/breakpoints";

$choices-width: 440px;

.divider {
  display: none;
  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 0px;
    margin-bottom:26px;
    border: none;
    border-bottom: 4px solid var(--blue-01);
    max-width: 15em;
  }
}

.overlay {
  flex: 1; // ensures component stretches to fill the screen verticall
}

.headline {
  @include typography.heading3;
  margin: 0;
}

.yourAnswer {
  
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  padding-top: 10px;
  padding-bottom: 15px;
  @include breakpoints.desktop {
    @include typography.body;
    padding-top: 4px;
    padding-bottom: 0px;
  }
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/people.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;
    height: math.div(100%, math.sin(90deg - $rotate-amount)); // stretch the diagonal area so it has the right height.
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.layout {
  padding: 20px var(--mobile-gutter);
  display: grid;
  padding-top: 0px;
  gap: 0;
  @include breakpoints.desktop {
    border-bottom: 1px solid var(--gray-06);
    min-height: 380px;
    height: 100%;
    overflow:auto;
    padding-top: 20px;
  }
}

.iWearGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: $choices-width;
  margin: 0 auto;
  @include breakpoints.desktop {
    //grid-area: choices;
    margin: 0px;
  }
}

.interrogative {
  @include typography.body-semibold;
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.qualifier {
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.button {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.buttons {
  display: flex;
  flex-direction: row;
}

.requiredMessage {
  color: red;
  padding-bottom: 0;
  padding-top: 0px;
  margin: 0px;
  font-size: 12px;
  font-weight: 600;
  @include breakpoints.desktop {
    padding-top: 5px;
    margin: 5px 0px 0px;
    font-size: 16px;
  }
}
